
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProfessionalNav from './components/ProfessionalNav';

const ProfessionnelsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <HeroSection />
        <ProfessionalNav />
      </main>
      <Footer />
    </div>
  );
};

export default ProfessionnelsPage;
